<template>
    <div class="content-wrap">
    <kapp-header id="mainHeader" :show-header="true"></kapp-header>
    <transition-group tag="div" class="" name="social-switch">

        <!--<div v-show="this.category === 'cat-insta'" key="instagram" class="p-t-2">
&lt;!&ndash;            <vue-instagram token="10725535870.4219de8.3d3a38c3dfb34505b3eba95ccae75f3a" :count="5">&ndash;&gt;
            <vue-instagram token="10725535870.4219de8.130ad01775be482a8055811f5cce3328" :count="5">
                <template slot="feeds" slot-scope="props">

                    <insta_post :post="props.feed" />

                </template>
                <template slot="error" slot-scope="props">
                    <div class="fancy-alert"> {{ props.error.error_message }}</div>
                </template>
            </vue-instagram>
        </div>-->
        <div class="" v-show="this.category === 'cat-fb'" key="facebook">
            <facebook pageid="KASSECKER"></facebook>
        </div>
    </transition-group>
    </div>
</template>

<script>

	import Facebook from '../components/plugins/Facebook/Facebook';
	import VueInstagram from 'vue-instagram';
	import InstaPost from '../components/plugins/Instagram/Post';
    import Header from '../components/layouts/Header';


	/**
	 https://api.instagram.com/oauth/access_token?client_id=4219de8411e54c4f98137626b12d1e0b&client_secret=f26d656395c244bfb776336b3c701299&grant_type=authorization_code&redirect_uri=https://app.kassecker.de/insta.php&code=1b5d7ad993084f26bd612700612c0dd1
	 */

	export default {
		name: "KappSocialMedia",
		components: {
			'facebook': Facebook,
            'insta_post' : InstaPost,
			VueInstagram,
            'kapp-header': Header
		},
		data() {
			return {
				category: 'cat-fb'
			};
		},
		props: [],
		methods: {
			changeGroup: function ( cat ) {
				this.category = cat;
			}
		},
		created() {
			// let subPages = [
			// 	// {
			// 	// 	uid: 'insta',
			// 	// 	title: 'Instagram'
			// 	// },
			// 	{
			// 		uid: 'fb',
			// 		title: 'Facebook'
			// 	}
			// ];

			// Events.$emit('showCategories', subPages);

			Events.$on('switchContentCategory', this.changeGroup);
		}
	};
</script>

<style scoped>
    .social-switch-enter-active,
    .social-switch-leave-active,
    .social-switch-enter-active,
    .social-switch-leave-active {
        position: absolute;
        /*top: 145px;*/
        left: 30px;
        right: 30px;
        width: auto;
    }

    .social-switch-enter-active {
        /*left: 60px;*/
        animation: slide-right .4s ease-in-out forwards;
    }

    .social-switch-leave-active {
        animation: slide-left .4s ease-in-out reverse forwards;
    }

    .social-switch-enter-active {
        animation: slide-left .4s ease-in-out forwards;
    }

    .social-switch-leave-active {
        animation: slide-right .4s ease-in-out reverse forwards;
    }
</style>



// WEBPACK FOOTER //
// src/pages/KappSocialMedia.vue